<template>
    <div class="container has-text-centered has-background-light p-4 m-5 rounded">
        
        <LoadingSpinner v-if="loading" class="m-3"/>
        <div v-else>
            <h6 class="title is-size-3 my-3">{{ post.tags.postTitle }}</h6>
            <div class="columns is-flex is-vcentered">        
                    <div class="column is-3">
                        <h5 class="title has-text-primary is-5 my-3">Author:</h5>
                        <h5 class="title my-3">{{ post.tags.postAuthor}}</h5>
                    </div>
                    <div class="column is-3">
                        <h5 class="title has-text-primary is-5 my-3">Date:</h5>
                        <h5 class="title my-3">{{ post.tags.postDate.substr(0, 10)}}</h5>
                    </div>
                <div class="column is-3">
                    <button 
                        class="button has-text-centered is-grey slightly-rounded"
                        @click="onOpenPost(post)"
                    >
                        <span class= "icon is-small"><i class="fa-solid fa-folder-open"></i></span>
                        <span>Open</span>
                    </button>
                </div>
                <div class="column is-3">
                    <button
                        @click="onDeletePost(post)"
                        class="button has-text-centered is-grey slightly-rounded"
                    >
                        <span class="icon has-text-danger"><i class="fas fa-trash"></i></span>
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue';
import { getS3FileTags, s3Decode } from '@/js/uploader';

async function getPostTags(postObject) {
    return await getS3FileTags(
        process.env.VUE_APP_BUCKET_BLOG,
        postObject.Key
    )
}

/**
 * 
 * @param {proxy} tags a proxy array of dictionaries which contain string values
 * @returns one combined dictionary
 */
function tagsFromS3(s3Tags) {
    return s3Tags.reduce((result, item) => {   
        result[item['Key']] = s3Decode(item['Value'])
        return result
    }, {})
}

export default {
    name: ['PostWrapper'],
    components: { LoadingSpinner },
    props: ['post'],
    emits: ['openPostClicked', 'deletePostClicked'],
    data() {
        return {
            loading: true
        }
    },
    methods: {
        onOpenPost(post) {
            this.$emit('openPostClicked', { post })
        },
        onDeletePost(post) {
            this.$emit('deletePostClicked', { post })
        },
        async getTags() {
            this.loading = true
            this.post.tags = tagsFromS3(await getPostTags(this.post))
            this.loading = false
        }
    },
    mounted() {
         // get the post's tags from s3
        this.getTags()    
    }
}
</script>

